import script from "./OrderGroupInfoSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderGroupInfoSection.vue?vue&type=script&setup=true&lang=ts"

import "./OrderGroupInfoSection.vue?vue&type=style&index=0&id=17ed3c4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ed3c4c"]])

export default __exports__